import React, { Component } from 'react';
import './Subject.module.scss';

//Import FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Subject extends Component {

    render() {

        const { abbreviation, color, misc, pause } = this.props;

        return (
            <div styleName="subject-background" style={this.props.style}>
                <div styleName="subject-wrapper">
                    <div style={{ backgroundColor: color }} styleName={'subject' + (color ? ' colored' : '')}>
                        <span styleName="subject-text">
                            {(abbreviation && (!misc || !pause)) && abbreviation} 
                            {misc && <FontAwesomeIcon icon={[ 'fas','thumbtack' ]}/>}
                            {pause && <FontAwesomeIcon icon={[ 'fas','pause' ]}/>}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default Subject;